<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.btn-info.disabled, .btn-info:disabled {
  cursor: no-drop;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Laporan Perolehan SKP
      <template v-if="role_status && role_status.status_export_excel">
      <CButton
        color="info"
        class="btn-md ml-auto"
        disabled
        v-if="tahun == '' && idKategoriAnggota == '' "
      >Ekspor Excel</CButton>
      <CButton
        color="info"
        class="btn-md ml-auto"
        v-else
        @click="exportDataSKP(tahun, idKategoriAnggota)"
      >Ekspor Excel</CButton>
      </template>
    </CCardHeader>
    <!-- Data BPK -->
    <CCardBody>
      <CRow class="mb-4">
          <div class="col-sm-12 col-xl-6">
            <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Tahun</label>
           
            <multiselect
              class="mulit-select"
              label="label"
              placeholder="Pilih Periode"
              :show-labels="false"
              required
              v-model="periode"
              @select="changePeriode"
              :options="dataTahun"
            ></multiselect>
          </div>
          </div>
          <div class="col-sm-12 col-xl-6">
            <div class="form-group">
              <label for="" class="font-weight-bold">Pilih Kategori Anggota</label>
              <multiselect
                class="mulit-select"
                label="namaKategori"
                placeholder="Pilih kategori anggota"
                id="kategoriSelect"
                :show-labels="false"
                required
                v-model="kategori"
                :options="dataKategori"
                @input="selectKategori"
              ></multiselect>
            </div>
          </div>
          <div class="col-md-12  text-right">
            <button class="btn btn-md btn-info mr-2" @click="resetFilter">Reset Filter</button>
            <button class="btn btn-md btn-success" @click="filterData">Terapkan</button>
          </div>
      </CRow>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive mt-2">
          <CDataTable
            style="width: 125% !important" 
            :items="items" 
            :fields="fields"           
            hover 
            sorter            
          >
            <template #no="{index}">
              <td class="py-2">
                {{ indexed == 0 ? index + 1 : index + indexed + 1 }}
              </td>
            </template>
            <template #nama_lengkap="{item}">
              <td class="py-2">{{item.nama_lengkap ? item.nama_lengkap : '-'}}</td>
            </template>
            <template #akumulasi_target_skp="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.akumulasi_target_skp ? item.akumulasi_target_skp : '0'}}</td>
            </template>
            <template #jumlah_skp_tidak_terstruktur="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.jumlah_skp_tidak_terstruktur ? item.jumlah_skp_tidak_terstruktur : '0'}}</td>
            </template>
            <template #jumlah_skp_terstruktur="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.jumlah_skp_terstruktur ? item.jumlah_skp_terstruktur : '0'}}</td>
            </template>
            <template #jumlah_skp_tidak_terstruktur_non_iapi="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.jumlah_skp_tidak_terstruktur_non_iapi ? item.jumlah_skp_tidak_terstruktur_non_iapi : '0'}}</td>
            </template>           
            <template #jumlah_skp_assessment="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.jumlah_skp_assessment ? item.jumlah_skp_assessment : '0'}}</td>
            </template>           
            <template #jumlah_skp_ap="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.jumlah_skp_ap ? item.jumlah_skp_ap : '0'}}</td>
            </template>    
            <template #status_laporan="{item}">
              <td class="py-2 text-center font-weight-bold">
                <span class="text-success" v-if="item.status_laporan == 'Sudah Melaporkan'">{{ item.status_laporan }}</span>
                <span class="text-warning" v-else>{{ item.status_laporan }}</span>
              </td>
            </template>
            <template #aksi="{item}">
              <td class="py-2 d-flex align-items-center">
                <router-link :to="{ 
                  path:'/keanggotaan/pelaporan-skp/detail', 
                  query: { id_user: item.id_user, tahun: periode.value }
                }">
                  <CButton 
                    v-c-tooltip="'Detail'" 
                    color="success" 
                    class="btn-sm" 
                    square>
                    <i class="fa fa-eye"></i>
                  </CButton>
                </router-link>
              </td>
            </template>
            <!-- <template #aksi>
              <td class="py-2 d-flex align-items-center text-center">
                <CButton v-c-tooltip="'Detail'" color="info" class="btn-sm" square>
                  <font-awesome-icon icon="eye" />
                </CButton>
              </td>
            </template> -->
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>

      
      <CModal
      title="Modal title"
      :show.sync="myModal"
      :no-close-on-backdrop="true"
      :centered="true"
      >
        <CRow>
          <div class="modal-body row my-n3">
            <div class="col-5">
              
              <p class="font-weight-bold">No Anggota</p>
              <p class="font-weight-bold">Nama Anggota</p>
              <p class="font-weight-bold">Kategori Anggota</p>
              <p class="font-weight-bold">Email</p>
              <p class="font-weight-bold">No. Handphone</p>
              <p class="font-weight-bold">No. Telepon</p>
              <p class="font-weight-bold">Nama Pelatihan</p>
              <p class="font-weight-bold">Nama Penyelenggara</p>
              <p class="font-weight-bold">Tanggal Pengajuan</p>
              <p class="font-weight-bold">Tanggal Pelatihan</p>
              <p class="font-weight-bold">Jumlah SKP</p>
              <p class="font-weight-bold">Jenis Pengajuan</p>
            </div>
            <div class="col-7">
              <p>: {{ detailData.no_anggota ? detailData.no_anggota : '-' }}</p>
              <p>: {{ detailData.nama_lengkap ? detailData.nama_lengkap : '-' }}</p>
              <p>: {{ detailData.nama_kategori ? detailData.nama_kategori : '-' }}</p>
              <p>: {{ detailData.email ? detailData.email : '-' }}</p>
              <p>: {{ detailData.no_handphone ? detailData.no_handphone : '-' }}</p>
              <p>: {{ detailData.no_telephone ? detailData.no_telephone : '-' }}</p>

              <p>: {{ detailData.nama_pelatihan ? detailData.nama_pelatihan : '-' }}</p>
              <p>: {{ detailData.nama_penyelenggara ? detailData.nama_penyelenggara : '-' }}</p>
              <p>: {{ detailData.tanggal_pengajuan ? detailData.tanggal_pengajuan : '-' }}</p>
              <p>: {{ detailData.tanggal_mulai + " - "+ detailData.tanggal_berakhir }}</p>
              <p>: {{ detailData.jumlah_skp ? detailData.jumlah_skp : '0' }}</p>
              <p>: {{ detailData.jenis_pengajuan_label ? detailData.jenis_pengajuan_label : '0' }}</p>
            </div>
          </div>
        </CRow>
        
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Detail Laporan SKP</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
        </template>
      </CModal>

    </CCardBody>
    <!-- End Data BPK -->
  </CCard>
</template>
<script>
import PelaporanSkpService from "@/services/keanggotaan/pelaporan-skp.service";
import KategoriAnggotaService from "@/services/keanggotaan/kategori-anggota.service";
import PeriodeService from '@/services/datamaster/periode.service'
import PeriodeRplService from '@/services/datamaster/periode-rpl.service'
import { AlertUtils } from "@/mixins/AlertUtils";
import { exportUtils } from "@/mixins/exportUtils";


const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama Lengkap",
    sorter: true,
    filter: true,
  },
  {
    key: "akumulasi_target_skp",
    label: "Kewajiban SKP",
    sorter: true,
    filter: true,
    _style: "text-align: center"
  },
  {
    key: "jumlah_skp_terstruktur",
    label: "Akumulasi SKP Terstruktur",
    sorter: true,
    filter: true,    
    _style: "text-align: center"
  },
  {
    key: "jumlah_skp_tidak_terstruktur",
    label: "Akumulasi SKP Tidak Terstruktur",
    sorter: true,
    filter: true,
    _style: "text-align: center"
  },
  {
    key: "jumlah_skp_tidak_terstruktur_non_iapi",
    label: "Akumulasi SKP Tidak Terstruktur Non Iapi",
    sorter: true,
    filter: true,
    _style: "text-align: center"
  },
  {
    key: "jumlah_skp_assessment",
    label: "Jumlah SKP Assessment",
    sorter: true,
    filter: true,
    _style: "text-align: center"
  },
  {
    key: "jumlah_skp_ap",
    label: "Akumulasi SKP AP",
    sorter: true,
    filter: true,
    _style: "text-align: center"
  },
  {
    key: "status_laporan",
    label: "Status Pelaporan",
    sorter: true,
    filter: true,
    _style: "text-align: center"
  },
  {
    key: "aksi",
    _style: "text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: 'pelaporan-skp',

  mixins: [AlertUtils, exportUtils],

  data() {
    return {
      items: [],
      searchData : '',
      dataKategori: [],
      dataTahun: [],
      dataPeriode : [],
      periode :'',
      kategori: "",
      tahun : '',
      timeout: 0,
      idKategoriAnggota: "",
      formData: {
        nama_lengkap: '',
        nama_kategori: '',
        skp_iapi_terstruktur: '',
        skp_non_iapi_terstruktur: '',
        tanggal_laporan: '',
        status: '',        
        id_pelaporan_skp: '',
      },
      fields,
      currentPage: 0,
      pagination: {
        totalPages: 0
      },
      search: '',
      pageSize: "10",
      detailData : {},
      item:[],
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  mounted() {
    this.getTahun();
    this.getKategori();
    this.roleData();
    this.getPeriode();
  },

  watch: {
    search: function(val) {
      if(val != "") {
          clearTimeout(this.timeout);
          var vm = this
          this.timeout = setTimeout(function () {
              // enter this block of code after 1 second
              // handle stuff, call search API etc.
              var searchVar = vm.search.trimStart();
              var searchFinal = searchVar.trimEnd();

              vm.getData("0", vm.pageSize, searchFinal, vm.kategori.idKategoriAnggota,vm.tahun);
          }, 1000);
      } else {
        this.getData("0", this.pageSize, this.search, this.kategori.idKategoriAnggota,this.tahun);
      }
     
    },

    currentPage: function(val) {
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search, this.kategori.idKategoriAnggota,this.tahun);
    },
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
      },
    changePeriode(value) {
      this.tahun = value.value
    },
    getTahun() {
      for (let index = 0; index < 30; index++) {
        this.dataTahun.push({
          label : 2020+index,
          value : 2020+index
        })
      }
    },
    
    Detail(item) {
      this.modalDetail = true;
      this.detailData = item
    },
   

    getData(currentPage, pageSize, filter, kategori,periode) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;

      PelaporanSkpService.getPelaporanSkp(currentPage, pageSize, filter, kategori,periode)
        .then((response) => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;

        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getKategori() {
      KategoriAnggotaService.getAllKategoriAnggota()
        .then((response) => {
          this.dataKategori = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },


    changeKategori(val) {
      this.kategori = val;      
    },
     
    changePageSize(e) {    
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search, this.kategori.idKategoriAnggota);
    },

    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search, this.kategori.idKategoriAnggota);
    },

    selectKategori(value) {
      this.idKategoriAnggota = value.idKategoriAnggota
    },

    filterData() {
      this.getData("0", this.pageSize, this.search, this.kategori.idKategoriAnggota,this.tahun);
    },
   resetFilter() {
      this.periode = "";
      this.tahun = "";
      this.kategori = "";
      this.kategori [
        {
          idKategoriAnggota: ""
        }
      ]
    },

    exportDataSKP(tahun, idKategoriAnggota) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });
        PelaporanSkpService.exportData(tahun, idKategoriAnggota)
        .then(response => {
            loader.hide()
            this.exportData(response.data, 'Data-Pelaporan-SKP');
            this.alertExportSuccess();
            this.getData("0", this.pageSize, this.search, this.kategori.idKategoriAnggota, this.tahun);
          })
        .catch(error => {
          loader.hide()
          this.alertExportFailed();
          this.getData("0", this.pageSize, this.search, this.kategori.idKategoriAnggota, this.tahun);
        })
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
